/**
 * Contenteditable Helpers
 * When using a contenteditable="true" HTML element.
 */

/**
 * Select all text inside contenteditable element.
 * @param {HTMLElement} target : The editable element
 */
export const selectAllText = (target) => {
  const selection = window.getSelection()
  const range = document.createRange()
  range.selectNodeContents(target)
  selection.removeAllRanges()
  selection.addRange(range)
}
